<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section>
                <div *ngIf="info.gerardata && info.generardatafaltante">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12 cardbasico">
                  <dx-pivot-grid #general style="overflow-x: scroll !important;"
                    [dataSource]="info.gerardata"
                    [showColumnGrandTotals]="false"
                    (onCellPrepared)="onCellPrepared($event, info.gerardata['store'], info.maxrespuesta)"
                    >
                    <dxo-field-chooser [enabled]="false"></dxo-field-chooser>
                  </dx-pivot-grid>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-12 cardbasico">
                  <dx-pivot-grid #faltante style="overflow-x: scroll !important;"
                    [dataSource]="info.generardatafaltante"
                    [showColumnGrandTotals]="false"
                    (onCellPrepared)="onCellPreparedFaltante($event, info.generardatafaltante['store'])">
                    <dxo-field-chooser [enabled]="false"></dxo-field-chooser>
                  </dx-pivot-grid>
                </div>
            </div>
            </section>
        </div>
    </div>

